module.exports = __webpack_public_path__ + "img/5.6d0605bb.jpg";